<template>
  <div id="app">
    <notifications group="app" position="bottom right" />
    <files-preview />
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
import metaMixin from '@/mixins/metaMixin';
import store from './store/index';
import FilesPreview from './components/FilesPreview';
import { checkVersion } from './utils/checkVersion';
import { needToCheckVersion } from './router.rules';

export default {
  name: 'app',
  mixins: [metaMixin],
  components: {
    FilesPreview
  },
  async created() {
    if (store.getters.isAuthenticated) {
      if (!needToCheckVersion.find((e) => location.pathname?.match(e))) {
        checkVersion();
      }
    }
  }
};
</script>
